import { IAddUpdateMenuRequest } from "../../../../model/admin-portal/request/add-update-menu-request";
import { ICustomPageListResponse } from "../../../../model/admin-portal/response/custom-page-list-response";
import { IMenuListResponse } from "../../../../model/admin-portal/response/menu-list-response";

export type MenusState = {
    dataListResponse: IMenuListResponse[];
    isLoadingData: boolean;
    dataResponse: IMenuListResponse | null;
    dataRequest: IAddUpdateMenuRequest;
    showAddEdit: boolean;
    customPagesList: ICustomPageListResponse[];
};

export const initialState: MenusState = {
    dataListResponse: [],
    isLoadingData: false,
    dataResponse: null,
    dataRequest: {
        id: null,
        title: '',
        customPageId: null,
        externalUrl: '',
        order: 1,
        visible: true,
        items: []
    },
    showAddEdit: false,
    customPagesList: []
};

export enum ACTION_TYPES {
    setDataListResponse = 'setDataListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setCustomPagesList = 'setCustomPagesList'
}

type Action =
    | { type: ACTION_TYPES.setDataListResponse; payload: IMenuListResponse[] }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: IMenuListResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateMenuRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setCustomPagesList; payload: ICustomPageListResponse[] };

export const menusReducer = (state: MenusState, action: Action): MenusState => {
    switch (action.type) {
        case ACTION_TYPES.setDataListResponse:
            return { ...state, dataListResponse: action.payload };

        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };

        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };

        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };

        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };

        case ACTION_TYPES.setCustomPagesList:
            return { ...state, customPagesList: action.payload };

        default:
            return state;
    }
};
